import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Kicker, H2 } from './ui/Typography';
export function ProblemSection() {
  const problems = [{
    num: '01',
    title: 'THEY TRY ALL 7 PATHS AT ONCE',
    desc: 'Shiny path syndrome. Pick one, finish it, then stack.'
  }, {
    num: '02',
    title: 'THEY CHARGE FOR OUTPUT, NOT OUTCOMES',
    desc: "Nobody pays for 'I used ChatGPT'. They pay for results."
  }, {
    num: '03',
    title: 'THEY PUBLISH OBVIOUS AI SLOP',
    desc: 'The edit is 70% of the value. Skip it and Google penalizes you.'
  }];
  return <Section hasOrb={true} data-id="element-157">
      <Kicker data-id="element-158">WHY MOST PEOPLE FAIL</Kicker>
      <H2 className="max-w-4xl" data-id="element-159">THE 3 REASONS 80% OF PEOPLE QUIT IN WEEK 3</H2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16" data-id="element-160">
        {problems.map((prob, i) => <Card key={i} delay={i * 0.1} className="flex flex-col" data-id="element-161">
            <span className="font-archivo text-brand text-5xl mb-6 opacity-50" data-id="element-162">
              {prob.num}
            </span>
            <h3 className="font-archivo text-xl uppercase tracking-tight mb-4" data-id="element-163">
              {prob.title}
            </h3>
            <p className="text-ink-dim leading-relaxed" data-id="element-164">{prob.desc}</p>
          </Card>)}
      </div>
    </Section>;
}